import { LocationUpdates } from "planning-portal-library/src/lib/core/domain/models/location-update";
import { Mapper } from "../../../../../core/base";
import { Plan } from "../../../../../core/domain";
import { LocationUpdateEntity } from "./location-update-entity";
import { DateTime, Duration } from "luxon";

export class LocationUpdateRepositoryMapper extends Mapper<LocationUpdateEntity, LocationUpdates> {

  mapFrom(param: LocationUpdateEntity): LocationUpdates {
    return {
      id: param.id!,
      createdAt: param.createdAt!,
      mlsid: param.mlsid!,
      locationId: param.locationId!,
      jobId: param.jobId!,
      planId: param.planId!,
      planContainerId: param.planContainerId!,
      applied: param.applied!,
      appliedAt: param.appliedAt!,
      appliedById: param.appliedById!,
      tenantId: param.tenantId!,
      key: param.key,
      oldValue: param.oldValue,
      newValue: param.newValue,
      updateType: param.updateType
    };
  }

  mapTo(param: LocationUpdates): LocationUpdateEntity {
    return {
      id: param.id,
      createdAt: param.createdAt,
      mlsid: param.mlsid,
      locationId: param.locationId,
      jobId: param.jobId,
      planId: param.planId,
      planContainerId: param.planContainerId,
      applied: param.applied,
      appliedAt: param.appliedAt,
      appliedById: param.appliedById,
      tenantId: param.tenantId,
      key: param.key,
      oldValue: param.oldValue,
      newValue: param.newValue,
      updateType: param.updateType
    };
  }

}
